module.exports = __webpack_public_path__ + "img/member_rights_icon.db01a637.png";